import { render } from "./ArrowLeft.vue?vue&type=template&id=2e6133c6&scoped=true"
import script from "./ArrowLeft.vue?vue&type=script&lang=js"
export * from "./ArrowLeft.vue?vue&type=script&lang=js"

import "./ArrowLeft.vue?vue&type=style&index=0&id=2e6133c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e6133c6"

export default script